module.exports = __webpack_public_path__ + "img/qt-gx@2x.68dc19b1.png";